import { key, piqure } from 'piqure';
import { provideLazy } from '@/supporting/account/injections.ts';
import { USERS_REPOSITORY } from '@/supporting/account/AccountKeys.ts';
import { type AuthenticatedFetcher, buildFetcher } from '@/generic/authentication';
import { UsersCleanApiHttp } from '@/supporting/account/secondary/UsersCleanApiHttp.ts';

const FETCHER = key<AuthenticatedFetcher>('Account fetcher');

const local = piqure();

export const provideAccount = () => {
  local.provideLazy(FETCHER, () => buildFetcher());

  provideLazy(USERS_REPOSITORY, () => new UsersCleanApiHttp(local.inject(FETCHER)));
};
